import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useKitchenStatus(pollMs = 30000) {
  const [status, setStatus] = useState({ is_open: true, message: null });
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await axios.get(`${API}/kitchen/status`);
      setStatus(data);
    } catch {
      // assume open on failure to avoid blocking accidentally
      setStatus({ is_open: true, message: null });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    if (!pollMs) return;
    const t = setInterval(refresh, pollMs);
    return () => clearInterval(t);
  }, [pollMs]);

  return { ...status, loading, refresh };
}
